import React from 'react';
import './LoadingSpinner.css'

const LoadingSpinner = ()=> (
    <div className="loading" id='spinner'>
<svg  version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="2000.000000pt" height="2000.000000pt" viewBox="0 0 2000.000000 2000.000000"
 preserveAspectRatio="xMidYMid meet">

  <g transform="translate(0.000000,2000.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path  d="M9717 16553 c-5 -4 -74 -11 -155 -15 -241 -13 -467 -38 -712 -78 -36
-6 -85 -13 -110 -16 -25 -3 -49 -10 -55 -15 -5 -5 -27 -9 -50 -9 -23 0 -45 -4
-50 -9 -6 -5 -28 -12 -50 -15 -22 -3 -59 -8 -83 -12 -23 -3 -45 -10 -48 -15
-3 -5 -20 -9 -39 -9 -19 0 -37 -4 -40 -10 -3 -5 -21 -10 -40 -10 -19 0 -36 -4
-39 -9 -3 -5 -20 -11 -38 -14 -53 -9 -92 -18 -113 -27 -11 -4 -40 -13 -65 -20
-25 -6 -53 -16 -62 -21 -10 -5 -29 -9 -42 -9 -14 0 -28 -4 -31 -10 -3 -5 -17
-10 -30 -10 -13 0 -27 -4 -30 -10 -3 -5 -17 -10 -30 -10 -13 0 -27 -4 -30 -10
-3 -5 -17 -10 -31 -10 -13 0 -24 -4 -24 -10 0 -5 -13 -10 -30 -10 -16 0 -30
-4 -30 -10 0 -5 -9 -10 -20 -10 -11 0 -30 -5 -43 -12 -48 -24 -57 -28 -77 -28
-11 0 -20 -4 -20 -8 0 -5 -22 -15 -50 -22 -27 -7 -50 -16 -50 -20 0 -4 -22
-13 -50 -20 -27 -7 -50 -17 -50 -22 0 -4 -6 -8 -13 -8 -12 0 -80 -29 -119 -50
-10 -6 -25 -10 -33 -10 -8 0 -15 -4 -15 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4
-20 -10 0 -5 -6 -10 -12 -10 -16 0 -342 -162 -346 -172 -2 -5 -12 -8 -23 -8
-10 0 -19 -4 -19 -10 0 -5 -9 -10 -19 -10 -11 0 -21 -3 -23 -7 -4 -10 -57 -42
-80 -50 -10 -3 -18 -9 -18 -14 0 -5 -9 -9 -20 -9 -11 0 -20 -4 -20 -9 0 -5
-13 -14 -30 -21 -16 -7 -30 -16 -30 -21 0 -5 -9 -9 -20 -9 -11 0 -20 -4 -20
-9 0 -5 -13 -14 -30 -21 -16 -7 -30 -16 -30 -20 0 -4 -8 -10 -17 -13 -23 -7
-72 -37 -97 -59 -11 -10 -26 -18 -33 -18 -7 0 -13 -4 -13 -8 0 -5 -12 -15 -27
-23 -16 -8 -37 -22 -47 -31 -11 -10 -26 -18 -33 -18 -7 0 -13 -3 -13 -8 0 -4
-18 -18 -40 -32 -22 -14 -40 -28 -40 -32 0 -5 -6 -8 -13 -8 -7 0 -22 -8 -33
-18 -10 -10 -35 -28 -54 -42 -19 -13 -37 -27 -40 -30 -3 -3 -21 -17 -40 -30
-19 -13 -42 -32 -51 -42 -9 -10 -21 -18 -26 -18 -5 0 -31 -20 -57 -45 -27 -25
-51 -45 -55 -45 -4 0 -28 -19 -52 -43 -25 -23 -60 -54 -79 -67 -19 -13 -51
-40 -70 -60 -20 -19 -65 -60 -100 -90 -81 -69 -411 -399 -448 -448 -15 -21
-47 -57 -72 -82 -25 -25 -57 -61 -70 -80 -13 -19 -36 -46 -50 -60 -14 -14 -37
-41 -50 -60 -13 -19 -31 -42 -40 -50 -9 -8 -27 -31 -40 -50 -14 -19 -37 -48
-52 -64 -16 -16 -28 -33 -28 -38 0 -4 -13 -22 -30 -40 -16 -17 -30 -36 -30
-42 0 -6 -9 -18 -20 -26 -11 -8 -20 -19 -20 -25 0 -5 -14 -26 -30 -45 -16 -19
-30 -40 -30 -45 0 -6 -9 -17 -20 -25 -11 -8 -20 -19 -20 -25 0 -6 -8 -20 -17
-31 -10 -10 -24 -31 -32 -46 -8 -16 -18 -28 -23 -28 -4 0 -8 -6 -8 -13 0 -7
-8 -22 -18 -33 -22 -25 -52 -74 -59 -96 -3 -10 -9 -18 -13 -18 -4 0 -13 -13
-20 -30 -7 -16 -16 -30 -21 -30 -5 0 -9 -9 -9 -20 0 -11 -4 -20 -9 -20 -5 0
-14 -13 -21 -30 -7 -16 -16 -30 -21 -30 -5 0 -9 -9 -9 -19 0 -11 -3 -21 -7
-23 -10 -4 -42 -57 -50 -80 -3 -10 -9 -18 -14 -18 -5 0 -9 -9 -9 -20 0 -11 -4
-20 -10 -20 -5 0 -10 -9 -10 -19 0 -11 -4 -21 -8 -23 -11 -4 -172 -327 -172
-344 0 -8 -4 -14 -10 -14 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10
-6 -10 -13 0 -12 -29 -80 -50 -119 -6 -10 -10 -25 -10 -33 0 -8 -4 -15 -8 -15
-5 0 -15 -22 -22 -50 -7 -28 -16 -50 -20 -50 -4 0 -13 -22 -20 -50 -7 -27 -17
-50 -22 -50 -4 0 -8 -9 -8 -20 0 -11 -4 -29 -10 -40 -5 -11 -14 -29 -20 -40
-5 -11 -10 -29 -10 -40 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16 -4
-30 -10 -30 -5 0 -10 -11 -10 -24 0 -14 -4 -28 -10 -31 -5 -3 -10 -17 -10 -30
0 -13 -4 -27 -10 -30 -5 -3 -10 -19 -10 -36 0 -16 -4 -29 -10 -29 -5 0 -10
-11 -10 -25 0 -14 -4 -33 -9 -43 -15 -29 -31 -87 -31 -110 0 -12 -4 -22 -9
-22 -5 0 -12 -16 -15 -35 -3 -19 -9 -51 -12 -70 -3 -19 -10 -38 -15 -41 -5 -3
-9 -20 -9 -39 0 -19 -4 -36 -9 -39 -5 -3 -11 -23 -14 -43 -3 -21 -11 -58 -17
-83 -6 -25 -14 -63 -17 -85 -3 -22 -9 -44 -14 -50 -5 -5 -9 -27 -9 -50 0 -23
-4 -45 -9 -50 -5 -6 -12 -30 -15 -55 -3 -25 -10 -74 -16 -110 -108 -655 -122
-1370 -40 -2010 13 -99 23 -167 60 -387 5 -32 14 -80 19 -108 6 -27 13 -66 16
-85 4 -19 10 -44 15 -55 5 -11 11 -36 14 -55 2 -19 9 -54 15 -77 6 -24 16 -62
22 -85 6 -24 13 -58 16 -76 3 -18 9 -35 14 -38 5 -3 9 -18 9 -34 0 -16 4 -32
10 -35 5 -3 10 -17 10 -31 0 -13 4 -32 9 -42 5 -9 14 -37 21 -62 7 -25 16 -53
21 -62 5 -10 9 -27 9 -37 0 -11 5 -23 10 -26 6 -3 10 -17 10 -30 0 -13 5 -27
10 -30 6 -3 10 -17 10 -30 0 -13 5 -27 10 -30 6 -3 10 -15 10 -26 0 -10 4 -28
10 -39 5 -11 15 -29 20 -40 6 -11 10 -29 10 -40 0 -11 5 -20 10 -20 6 0 10 -9
10 -20 0 -11 4 -28 9 -38 9 -18 28 -62 41 -97 5 -11 17 -41 29 -67 12 -26 21
-55 21 -63 0 -8 5 -15 10 -15 6 0 10 -6 10 -13 0 -12 29 -80 50 -119 6 -10 10
-25 10 -33 0 -8 5 -15 10 -15 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9
10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10
-20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20
0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -19 0
-11 3 -21 8 -23 6 -3 36 -55 66 -115 6 -13 14 -23 19 -23 4 0 7 -9 7 -19 0
-11 3 -21 8 -23 9 -4 41 -57 49 -80 3 -10 9 -18 14 -18 5 0 9 -9 9 -20 0 -11
4 -20 9 -20 5 0 13 -9 16 -20 3 -11 12 -26 18 -33 17 -18 47 -69 54 -89 3 -10
9 -18 13 -18 4 0 13 -13 20 -30 7 -16 16 -30 21 -30 5 0 9 -6 9 -13 0 -7 9
-23 20 -35 11 -12 20 -25 20 -29 0 -4 11 -21 25 -37 14 -16 25 -32 25 -36 0
-4 11 -20 25 -36 14 -16 25 -34 25 -39 0 -6 9 -17 20 -25 11 -8 20 -19 20 -25
0 -6 8 -20 18 -31 10 -10 28 -35 42 -54 13 -19 27 -37 30 -40 3 -3 17 -21 30
-40 13 -19 31 -42 40 -50 9 -8 27 -31 40 -50 13 -19 31 -42 40 -50 9 -8 27
-31 40 -50 14 -19 39 -49 56 -67 18 -17 45 -49 60 -70 16 -20 56 -65 89 -99
33 -34 96 -102 140 -151 44 -48 129 -133 188 -188 59 -55 144 -135 189 -178
77 -73 118 -95 118 -62 0 8 4 15 8 15 4 0 16 14 26 30 9 17 29 42 42 55 l25
25 -54 52 c-29 29 -82 78 -117 108 -84 71 -290 277 -360 360 -30 35 -75 85
-100 110 -25 25 -57 61 -72 81 -15 20 -45 55 -67 78 -23 24 -41 46 -41 51 0 4
-20 29 -45 56 -25 26 -45 52 -45 57 0 5 -8 17 -18 26 -10 9 -29 32 -42 51 -13
19 -27 37 -30 40 -3 3 -17 21 -30 40 -14 19 -32 44 -42 54 -10 11 -18 24 -18
29 0 5 -8 17 -18 26 -9 9 -23 28 -31 43 -8 16 -18 28 -23 28 -4 0 -8 6 -8 13
0 7 -8 22 -17 33 -10 10 -24 31 -32 47 -8 15 -18 27 -23 27 -4 0 -8 6 -8 13 0
7 -8 22 -17 33 -23 25 -53 74 -60 96 -3 10 -9 18 -14 18 -5 0 -9 6 -9 13 0 7
-9 23 -20 35 -11 12 -20 28 -20 37 0 8 -4 15 -9 15 -5 0 -11 8 -14 18 -6 17
-37 72 -47 82 -6 6 -50 86 -65 117 -5 13 -13 23 -17 23 -5 0 -8 9 -8 20 0 11
-4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 19 0 11 -3
21 -8 23 -10 4 -92 170 -92 186 0 6 -4 12 -10 12 -5 0 -10 9 -10 20 0 11 -4
20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 7 -10 15 0 8 -4 24
-10 35 -5 11 -14 29 -20 40 -5 11 -10 27 -10 35 0 8 -4 15 -10 15 -5 0 -10 7
-10 15 0 8 -5 24 -10 35 -5 11 -14 29 -20 40 -5 11 -10 27 -10 35 0 8 -4 15
-8 15 -5 0 -15 22 -22 50 -7 27 -17 50 -22 50 -4 0 -8 11 -8 24 0 14 -4 27 -8
30 -4 3 -14 28 -22 56 -8 28 -18 53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24 -10
24 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10
30 -5 0 -10 11 -10 25 0 14 -4 33 -9 43 -5 9 -15 37 -21 62 -7 25 -16 54 -20
65 -9 21 -18 60 -27 113 -3 17 -9 32 -14 32 -5 0 -9 15 -9 34 0 19 -4 38 -10
41 -5 3 -10 21 -10 40 0 19 -5 37 -10 40 -6 3 -10 24 -10 45 0 21 -4 41 -9 44
-5 3 -11 23 -14 43 -3 21 -11 62 -16 91 -28 137 -33 161 -42 217 -70 430 -93
705 -92 1145 0 414 18 672 73 1035 6 39 13 93 16 120 3 28 10 54 15 60 5 5 9
30 9 56 0 26 5 51 10 54 6 3 10 23 10 44 0 20 4 41 9 47 5 5 11 27 14 49 3 22
10 59 16 83 6 23 15 59 21 80 24 94 32 129 37 160 3 17 9 32 14 32 5 0 9 10 9
22 0 23 16 81 31 110 5 10 9 29 9 43 0 14 5 25 10 25 6 0 10 13 10 29 0 17 5
33 10 36 6 3 10 17 10 30 0 13 5 27 10 30 5 3 10 17 10 30 0 13 5 27 10 30 6
3 10 17 10 31 0 13 5 24 10 24 6 0 10 14 10 30 0 17 4 30 8 30 5 0 15 23 22
50 7 28 17 50 22 50 4 0 8 9 8 20 0 11 4 28 9 38 5 9 14 31 21 47 7 17 16 38
21 47 5 10 9 25 9 33 0 8 5 15 10 15 6 0 10 7 10 15 0 8 5 24 10 35 6 11 15
29 20 40 6 11 10 27 10 35 0 8 5 15 10 15 6 0 10 9 10 20 0 11 5 20 10 20 6 0
10 5 10 12 0 17 27 77 96 213 90 177 108 210 117 213 4 2 7 12 7 22 0 10 3 20
8 22 9 4 41 57 49 81 3 9 9 17 14 17 5 0 9 9 9 20 0 11 4 20 9 20 5 0 11 8 14
18 7 21 37 71 55 90 6 7 12 17 12 22 0 5 6 15 13 22 6 8 18 24 25 36 6 12 18
32 25 44 6 12 20 31 29 42 10 11 18 24 18 28 0 5 9 18 20 30 11 12 20 28 20
35 0 7 4 13 8 13 4 0 15 12 24 28 9 15 28 41 42 57 14 17 26 35 26 40 0 6 9
17 20 25 11 8 20 19 20 25 0 6 8 20 18 31 10 10 28 35 42 54 13 19 32 42 42
51 10 9 18 21 18 26 0 6 12 23 28 39 15 16 38 45 52 64 13 19 36 46 50 60 14
14 37 41 50 60 13 19 40 51 60 70 19 19 55 60 80 90 58 70 453 466 504 504 21
16 57 47 80 70 22 23 57 52 76 66 19 13 46 36 60 50 14 14 41 37 60 50 19 13
42 31 50 40 8 9 31 27 50 40 19 13 37 27 40 30 3 3 21 17 40 30 19 13 37 27
40 30 3 3 21 17 40 30 19 14 44 32 54 42 11 10 26 18 33 18 7 0 13 4 13 8 0 5
12 15 28 23 15 8 34 21 42 29 8 8 27 21 43 29 15 8 27 18 27 23 0 4 6 8 13 8
7 0 22 8 33 18 25 22 74 52 97 59 9 3 17 9 17 14 0 5 6 9 13 9 7 0 22 8 33 18
25 22 74 52 97 59 9 3 17 9 17 14 0 5 9 9 20 9 11 0 20 4 20 8 0 4 22 19 50
33 27 13 50 27 50 32 0 4 9 7 19 7 11 0 21 3 23 8 4 9 51 34 233 124 77 39
157 78 178 89 22 10 45 19 53 19 8 0 14 5 14 10 0 6 7 10 15 10 8 0 24 5 35
10 11 6 29 15 40 20 11 6 27 10 35 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 23 4
33 9 9 5 31 14 47 21 17 7 38 16 47 21 10 5 27 9 38 9 11 0 20 4 20 8 0 5 23
15 50 22 28 7 50 17 50 22 0 4 14 8 30 8 17 0 30 5 30 10 0 6 11 10 24 10 14
0 28 5 31 10 3 6 17 10 30 10 13 0 27 5 30 10 3 6 17 10 30 10 13 0 27 5 30
10 3 6 17 10 30 10 13 0 27 5 30 10 3 6 19 10 36 10 16 0 29 4 29 9 0 5 16 12
35 15 19 3 51 9 70 12 19 3 35 10 35 14 0 4 15 10 33 13 17 3 51 10 75 16 23
6 61 16 85 21 23 6 60 16 82 21 22 6 58 13 80 16 22 3 44 9 50 14 5 5 25 9 45
9 20 0 40 4 45 9 6 5 33 12 60 15 28 2 77 10 110 16 359 65 703 93 1155 93
451 0 798 -28 1155 -93 33 -6 83 -14 110 -16 28 -3 54 -10 60 -15 5 -5 25 -9
45 -9 20 0 40 -4 46 -9 5 -5 27 -11 49 -14 37 -5 71 -13 165 -37 81 -21 127
-32 158 -37 17 -3 32 -9 32 -13 0 -7 12 -10 103 -26 20 -3 37 -10 37 -15 0 -5
14 -9 30 -9 17 0 30 -4 30 -10 0 -5 13 -10 29 -10 17 0 33 -4 36 -10 3 -5 17
-10 30 -10 13 0 27 -4 30 -10 3 -5 17 -10 30 -10 13 0 27 -4 30 -10 3 -5 17
-10 31 -10 13 0 24 -4 24 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -8 0 -5 23
-15 50 -22 28 -7 50 -17 50 -22 0 -4 9 -8 20 -8 11 0 28 -4 38 -9 9 -5 31 -14
47 -21 17 -7 38 -16 47 -21 10 -5 25 -9 33 -9 8 0 15 -4 15 -10 0 -5 7 -10 15
-10 8 0 24 -4 35 -10 11 -5 29 -14 40 -20 11 -5 27 -10 35 -10 8 0 15 -4 15
-10 0 -5 6 -10 14 -10 8 0 31 -9 53 -19 21 -11 101 -50 178 -89 182 -90 229
-115 233 -124 2 -5 12 -8 23 -8 10 0 19 -4 19 -9 0 -5 8 -11 18 -14 23 -8 76
-40 80 -49 2 -5 12 -8 23 -8 10 0 19 -4 19 -9 0 -5 14 -14 30 -21 17 -7 30
-16 30 -21 0 -5 7 -9 15 -9 9 0 25 -9 37 -20 12 -11 28 -20 35 -20 7 0 13 -4
13 -10 0 -5 6 -10 13 -10 7 0 23 -9 35 -20 12 -11 28 -20 37 -20 8 0 15 -4 15
-8 0 -5 12 -15 28 -23 15 -8 36 -22 46 -31 11 -10 24 -18 29 -18 5 0 17 -8 26
-18 9 -9 28 -23 44 -31 15 -8 27 -18 27 -23 0 -4 6 -8 13 -8 7 0 22 -8 33 -18
10 -10 35 -28 54 -42 19 -13 37 -27 40 -30 3 -3 21 -17 40 -30 19 -13 42 -32
51 -42 9 -10 21 -18 26 -18 6 0 23 -12 39 -28 16 -15 45 -38 64 -52 19 -13 46
-36 60 -50 14 -14 41 -37 60 -50 19 -13 51 -40 70 -60 19 -19 60 -55 90 -80
71 -58 442 -429 500 -500 25 -30 61 -71 80 -90 20 -19 47 -51 60 -70 13 -19
36 -46 50 -60 14 -14 37 -41 50 -60 14 -19 37 -48 52 -64 16 -16 28 -33 28
-39 0 -5 8 -17 18 -26 10 -9 29 -32 42 -51 14 -19 32 -44 42 -54 10 -11 18
-25 18 -31 0 -6 9 -17 20 -25 11 -8 20 -19 20 -25 0 -5 14 -26 30 -45 16 -19
30 -40 30 -45 0 -6 9 -17 20 -25 11 -8 20 -19 20 -25 0 -6 8 -20 18 -31 9 -10
23 -31 31 -46 8 -16 18 -28 23 -28 4 0 8 -7 8 -15 0 -9 9 -25 20 -37 11 -12
20 -28 20 -35 0 -7 5 -13 10 -13 6 0 10 -6 10 -13 0 -7 9 -23 20 -35 11 -12
20 -28 20 -37 0 -8 4 -15 9 -15 5 0 14 -13 21 -30 7 -16 16 -30 21 -30 5 0 9
-9 9 -20 0 -11 4 -20 9 -20 5 0 11 -8 14 -17 8 -24 40 -77 50 -81 4 -2 7 -12
7 -23 0 -10 5 -19 10 -19 6 0 10 -9 10 -19 0 -11 3 -21 8 -23 8 -4 35 -52 104
-193 27 -55 58 -117 68 -138 11 -22 20 -45 20 -53 0 -8 5 -14 10 -14 6 0 10
-9 10 -20 0 -11 5 -20 10 -20 6 0 10 -7 10 -15 0 -8 5 -25 12 -38 24 -47 28
-57 28 -72 0 -8 5 -15 10 -15 6 0 10 -7 10 -15 0 -8 4 -23 9 -33 5 -9 14 -30
21 -47 7 -16 16 -38 21 -47 5 -10 9 -27 9 -38 0 -11 4 -20 8 -20 5 0 15 -23
22 -51 8 -27 18 -52 22 -55 4 -3 8 -16 8 -30 0 -13 5 -24 10 -24 6 0 10 -13
10 -30 0 -16 5 -30 10 -30 6 0 10 -11 10 -24 0 -14 5 -28 10 -31 6 -3 10 -17
10 -30 0 -13 5 -27 10 -30 6 -3 10 -19 10 -36 0 -16 5 -29 10 -29 6 0 10 -11
10 -25 0 -14 4 -33 9 -43 14 -29 31 -87 31 -110 0 -11 5 -24 10 -27 6 -3 10
-19 10 -35 0 -16 4 -31 9 -34 5 -3 11 -20 14 -38 3 -18 10 -51 16 -73 27 -105
33 -133 38 -170 3 -22 9 -44 14 -50 5 -5 9 -25 9 -45 0 -20 4 -40 9 -45 5 -6
12 -32 15 -60 3 -27 8 -72 11 -100 3 -27 10 -59 15 -70 5 -11 12 -45 15 -75 3
-30 10 -89 15 -130 65 -498 73 -1088 20 -1605 -9 -85 -16 -145 -40 -310 -6
-38 -13 -90 -16 -115 -3 -25 -9 -54 -14 -65 -5 -11 -11 -38 -14 -60 -3 -22
-10 -65 -16 -95 -6 -30 -14 -72 -17 -93 -3 -20 -9 -40 -14 -43 -5 -3 -9 -23
-9 -44 0 -21 -4 -42 -10 -45 -5 -3 -10 -21 -10 -40 0 -19 -4 -37 -10 -40 -5
-3 -10 -22 -10 -41 0 -19 -4 -34 -9 -34 -5 0 -11 -15 -14 -32 -9 -53 -18 -92
-27 -113 -4 -11 -13 -40 -20 -65 -6 -25 -16 -53 -21 -62 -5 -10 -9 -29 -9 -43
0 -14 -4 -25 -10 -25 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -13
-10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -10 -10 -23 0 -13 -4 -27 -8 -32 -4 -6
-14 -28 -21 -50 -7 -22 -17 -51 -23 -65 -6 -14 -15 -36 -21 -50 -5 -14 -13
-33 -18 -42 -5 -10 -9 -27 -9 -38 0 -11 -4 -20 -10 -20 -5 0 -10 -7 -10 -15 0
-15 -4 -25 -28 -72 -7 -13 -12 -30 -12 -38 0 -8 -4 -15 -10 -15 -5 0 -10 -7
-10 -15 0 -8 -4 -24 -10 -35 -5 -11 -14 -29 -20 -40 -6 -11 -10 -27 -10 -35 0
-8 -4 -15 -10 -15 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10
-20 0 -11 -4 -20 -10 -20 -5 0 -10 -6 -10 -12 0 -16 -82 -182 -92 -186 -5 -2
-8 -12 -8 -23 0 -10 -4 -19 -10 -19 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20
-5 0 -10 -9 -10 -19 0 -11 -3 -21 -7 -23 -10 -4 -42 -57 -50 -80 -3 -10 -9
-18 -14 -18 -5 0 -9 -9 -9 -19 0 -11 -3 -21 -7 -23 -10 -4 -42 -57 -50 -80 -3
-10 -9 -18 -14 -18 -5 0 -9 -7 -9 -15 0 -9 -9 -25 -20 -37 -11 -12 -20 -28
-20 -35 0 -7 -4 -13 -10 -13 -5 0 -10 -6 -10 -13 0 -7 -9 -23 -20 -35 -11 -12
-20 -28 -20 -37 0 -8 -4 -15 -8 -15 -5 0 -15 -12 -23 -27 -8 -16 -22 -37 -31
-47 -10 -11 -18 -24 -18 -28 0 -5 -9 -18 -20 -30 -11 -12 -20 -28 -20 -35 0
-7 -3 -13 -8 -13 -4 0 -18 -18 -32 -40 -14 -22 -28 -40 -32 -40 -5 0 -8 -6 -8
-13 0 -7 -8 -22 -18 -33 -10 -10 -28 -35 -42 -54 -13 -19 -27 -37 -30 -40 -3
-3 -17 -21 -30 -40 -14 -19 -35 -45 -47 -58 -13 -13 -23 -27 -23 -32 0 -5 -15
-24 -33 -42 -18 -18 -43 -49 -57 -68 -13 -19 -36 -46 -50 -60 -14 -14 -37 -41
-50 -60 -13 -19 -45 -55 -70 -80 -25 -25 -70 -74 -100 -109 -70 -83 -277 -290
-360 -361 -36 -30 -88 -78 -117 -107 -28 -28 -59 -56 -69 -61 -21 -12 -13 -36
26 -82 16 -19 30 -41 30 -47 0 -7 5 -13 10 -13 6 0 10 -7 10 -15 0 -22 13 -19
56 15 129 99 619 587 708 704 15 21 42 52 60 69 17 18 42 48 56 67 13 19 31
42 40 50 9 8 27 31 40 50 14 19 37 48 52 64 16 16 28 33 28 38 0 4 14 22 30
40 17 17 30 35 30 40 0 4 14 22 30 40 16 17 30 35 30 41 0 5 8 17 18 26 9 9
23 28 31 43 8 16 18 28 23 28 4 0 8 6 8 13 0 6 11 25 25 41 13 16 27 37 30 47
4 11 10 19 14 19 5 0 14 14 21 30 7 17 16 30 21 30 5 0 9 6 9 13 0 7 8 22 18
33 22 25 52 74 59 96 3 10 9 18 14 18 5 0 9 6 9 13 0 7 9 23 20 35 11 12 20
28 20 36 0 8 3 16 8 18 9 4 41 57 49 80 3 10 9 18 14 18 5 0 9 9 9 19 0 11 3
21 8 23 7 3 45 69 67 115 5 13 13 23 18 23 4 0 7 9 7 20 0 11 5 20 10 20 6 0
10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0
11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20
6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 6 10 14 0 12 14 44 51 118 5 10 9 25 9
33 0 8 5 15 10 15 6 0 10 9 10 20 0 11 4 20 8 20 5 0 15 22 22 50 7 27 17 50
22 50 4 0 8 9 8 19 0 11 5 23 10 26 6 3 10 17 10 31 0 13 5 24 10 24 6 0 10 9
10 19 0 11 5 23 10 26 6 3 10 17 10 31 0 13 5 24 10 24 6 0 10 11 10 24 0 14
4 27 8 30 4 3 14 28 22 56 8 28 18 53 22 56 4 3 8 16 8 29 0 13 5 27 10 30 6
3 10 17 10 30 0 13 5 27 10 30 6 3 10 15 10 26 0 10 4 27 9 37 15 29 31 87 31
110 0 12 5 22 10 22 6 0 10 13 10 29 0 17 5 33 10 36 6 3 10 19 10 35 0 16 5
32 10 35 6 3 10 21 10 40 0 19 4 36 9 39 8 6 14 31 27 119 4 20 10 40 15 43 5
3 9 23 9 44 0 21 5 42 10 45 6 3 10 24 10 45 0 21 5 42 10 45 6 3 10 25 10 49
0 23 4 46 9 52 5 5 12 32 15 59 3 28 10 79 16 115 117 704 124 1418 21 2145
-14 93 -28 178 -41 245 -6 30 -13 73 -16 95 -3 22 -9 49 -14 60 -5 11 -11 36
-14 55 -2 19 -10 55 -16 80 -6 25 -14 59 -16 75 -3 17 -9 39 -14 50 -5 11 -11
34 -15 50 -3 17 -11 48 -16 70 -6 22 -13 55 -16 73 -3 17 -9 32 -14 32 -5 0
-9 10 -9 22 0 23 -16 81 -31 110 -5 10 -9 29 -9 43 0 14 -4 25 -10 25 -5 0
-10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0
-10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 11 -10 24 0 14 -4 28 -10 31 -5 3
-10 15 -10 26 0 10 -4 28 -10 39 -5 11 -14 29 -20 40 -5 11 -10 29 -10 40 0
11 -4 20 -8 20 -5 0 -15 23 -22 50 -7 28 -16 50 -20 50 -4 0 -13 23 -20 50 -7
28 -17 50 -22 50 -4 0 -8 9 -8 20 0 11 -4 20 -10 20 -5 0 -10 7 -10 15 0 9 -9
35 -20 57 -11 23 -20 48 -20 55 0 7 -4 13 -10 13 -5 0 -10 9 -10 20 0 11 -4
20 -10 20 -5 0 -10 6 -10 13 0 16 -162 341 -172 345 -4 2 -8 12 -8 22 0 10 -3
20 -7 22 -8 3 -46 69 -68 115 -5 13 -13 23 -17 23 -5 0 -8 9 -8 20 0 11 -4 20
-9 20 -5 0 -14 14 -21 30 -7 17 -16 30 -21 30 -5 0 -9 9 -9 20 0 11 -4 20 -9
20 -5 0 -14 14 -21 30 -7 17 -16 30 -20 30 -4 0 -10 8 -13 18 -7 22 -37 71
-59 96 -10 11 -18 24 -18 28 0 5 -9 18 -20 30 -11 12 -20 28 -20 35 0 7 -3 13
-8 13 -4 0 -18 18 -32 40 -14 22 -28 40 -32 40 -5 0 -8 6 -8 13 0 6 -14 28
-30 47 -16 19 -30 40 -30 45 0 6 -9 17 -20 25 -11 8 -20 20 -20 26 0 6 -13 25
-30 42 -16 18 -30 36 -30 40 0 5 -12 22 -28 38 -15 16 -38 45 -52 64 -13 19
-31 42 -40 50 -9 8 -27 31 -40 50 -13 19 -36 46 -50 60 -14 14 -37 41 -50 60
-13 19 -45 55 -70 80 -25 25 -70 75 -100 110 -71 84 -340 352 -410 410 -30 25
-75 65 -100 90 -25 25 -61 57 -80 70 -19 13 -46 36 -60 50 -14 14 -41 37 -60
50 -19 14 -50 39 -68 57 -18 18 -37 33 -42 33 -5 0 -19 10 -32 23 -13 12 -39
33 -58 47 -19 13 -44 32 -54 42 -11 10 -24 18 -28 18 -5 0 -20 11 -33 24 -13
14 -34 27 -45 31 -11 3 -20 9 -20 13 0 4 -18 18 -40 32 -22 14 -40 28 -40 32
0 5 -6 8 -13 8 -7 0 -22 8 -33 18 -10 9 -31 23 -46 31 -16 8 -28 18 -28 23 0
4 -6 8 -13 8 -7 0 -22 8 -33 18 -25 22 -74 52 -96 59 -10 3 -18 9 -18 13 0 4
-13 13 -30 20 -16 7 -30 16 -30 21 0 5 -9 9 -20 9 -11 0 -20 4 -20 9 0 5 -13
14 -30 21 -16 7 -30 16 -30 21 0 5 -9 9 -19 9 -11 0 -21 3 -23 8 -4 9 -57 41
-80 49 -10 3 -18 9 -18 14 0 5 -9 9 -20 9 -11 0 -20 5 -20 10 0 6 -9 10 -19
10 -11 0 -21 3 -23 8 -4 10 -330 172 -345 172 -7 0 -13 5 -13 10 0 6 -9 10
-20 10 -11 0 -20 5 -20 10 0 6 -6 10 -13 10 -7 0 -32 9 -55 20 -22 11 -48 20
-57 20 -8 0 -15 5 -15 10 0 6 -9 10 -20 10 -11 0 -20 4 -20 8 0 5 -22 15 -50
22 -27 7 -50 16 -50 20 0 4 -22 13 -50 20 -27 7 -50 17 -50 22 0 4 -9 8 -20 8
-20 0 -29 4 -77 28 -13 7 -32 12 -43 12 -11 0 -20 5 -20 10 0 6 -13 10 -30 10
-16 0 -30 5 -30 10 0 6 -11 10 -24 10 -14 0 -28 5 -31 10 -3 6 -17 10 -30 10
-13 0 -27 5 -30 10 -3 6 -19 10 -36 10 -16 0 -29 5 -29 10 0 6 -11 10 -25 10
-14 0 -33 4 -43 9 -9 5 -37 15 -62 21 -25 7 -54 16 -65 20 -21 9 -60 18 -113
27 -18 3 -35 9 -38 14 -3 5 -20 9 -39 9 -19 0 -37 5 -40 10 -3 6 -21 10 -40
10 -19 0 -36 4 -39 9 -6 8 -24 12 -128 27 -24 3 -47 10 -52 15 -6 5 -28 9 -51
9 -23 0 -45 4 -50 9 -6 5 -30 12 -55 15 -25 3 -74 10 -110 16 -221 36 -449 62
-710 81 -183 13 -714 22 -723 12z"/>
<path d="M10003 13755 c-13 -13 -23 -31 -23 -39 0 -8 -4 -18 -10 -21 -5 -3
-10 -19 -10 -35 0 -16 -4 -32 -10 -35 -5 -3 -10 -19 -10 -35 0 -16 -4 -32 -10
-35 -5 -3 -10 -17 -10 -31 0 -13 -4 -32 -9 -42 -24 -48 -51 -131 -51 -160 0
-12 -4 -22 -10 -22 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -13
-10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -11 -10 -24 0 -14 -4 -27 -8 -30 -4 -3
-14 -28 -22 -55 -7 -28 -17 -51 -22 -51 -4 0 -8 -13 -8 -30 0 -16 -4 -30 -10
-30 -5 0 -10 -11 -10 -24 0 -14 -4 -27 -8 -30 -4 -3 -14 -28 -22 -56 -8 -28
-18 -53 -22 -56 -4 -3 -8 -16 -8 -30 0 -13 -4 -24 -10 -24 -5 0 -10 -11 -10
-24 0 -14 -4 -27 -8 -30 -4 -3 -14 -28 -22 -56 -8 -28 -18 -53 -22 -56 -4 -3
-8 -16 -8 -30 0 -13 -4 -24 -10 -24 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10
-30 -5 0 -10 -9 -10 -20 0 -11 -4 -29 -10 -40 -5 -11 -14 -29 -20 -40 -5 -11
-10 -29 -10 -39 0 -11 -4 -23 -10 -26 -5 -3 -10 -17 -10 -31 0 -13 -4 -24 -10
-24 -5 0 -10 -11 -10 -24 0 -14 -4 -27 -8 -30 -4 -3 -14 -28 -22 -56 -8 -28
-18 -53 -22 -56 -4 -3 -8 -16 -8 -30 0 -13 -4 -24 -10 -24 -5 0 -10 -10 -10
-22 0 -25 -22 -93 -33 -104 -4 -4 -7 -18 -7 -31 0 -13 -4 -23 -10 -23 -5 0
-10 -11 -10 -24 0 -14 -4 -28 -10 -31 -5 -3 -10 -17 -10 -30 0 -13 -4 -26 -8
-29 -4 -3 -14 -28 -22 -56 -8 -28 -18 -53 -22 -56 -4 -3 -8 -16 -8 -30 0 -13
-4 -24 -10 -24 -5 0 -10 -11 -10 -24 0 -14 -4 -28 -10 -31 -5 -3 -10 -17 -10
-30 0 -13 -4 -26 -8 -29 -4 -3 -14 -28 -22 -56 -8 -28 -18 -53 -22 -56 -4 -3
-8 -16 -8 -30 0 -13 -4 -24 -10 -24 -5 0 -10 -11 -10 -24 0 -14 -4 -28 -10
-31 -5 -3 -10 -17 -10 -30 0 -13 -4 -26 -8 -29 -4 -3 -14 -28 -22 -56 -8 -28
-18 -53 -22 -56 -4 -3 -8 -16 -8 -30 0 -13 -4 -24 -10 -24 -5 0 -10 -13 -10
-30 0 -16 -4 -30 -10 -30 -5 0 -10 -11 -10 -24 0 -14 -4 -27 -8 -30 -4 -3 -14
-28 -22 -56 -8 -28 -18 -53 -22 -56 -4 -3 -8 -16 -8 -29 0 -13 -4 -27 -10 -30
-5 -3 -10 -17 -10 -31 0 -13 -4 -24 -10 -24 -5 0 -10 -10 -10 -23 0 -13 -4
-27 -8 -33 -5 -5 -19 -43 -32 -84 -13 -41 -27 -79 -32 -85 -4 -5 -8 -19 -8
-32 0 -13 -4 -23 -10 -23 -5 0 -10 -11 -10 -24 0 -14 -4 -28 -10 -31 -5 -3
-10 -17 -10 -30 0 -13 -4 -26 -8 -29 -4 -3 -14 -28 -22 -56 -8 -28 -18 -53
-22 -56 -4 -3 -8 -16 -8 -29 0 -13 -4 -27 -10 -30 -5 -3 -10 -17 -10 -31 0
-13 -4 -24 -10 -24 -5 0 -10 -10 -10 -23 0 -13 -4 -27 -8 -32 -5 -6 -19 -44
-32 -85 -13 -41 -27 -79 -32 -85 -4 -5 -8 -19 -8 -32 0 -13 -4 -23 -10 -23 -5
0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -10 -10 -23 0 -13 -4 -27 -8
-32 -5 -6 -19 -44 -32 -85 -13 -41 -27 -79 -32 -85 -4 -5 -8 -19 -8 -32 0 -13
-4 -23 -10 -23 -5 0 -10 -11 -10 -24 0 -14 -4 -28 -10 -31 -5 -3 -10 -16 -10
-29 0 -12 -4 -26 -8 -31 -5 -6 -19 -44 -32 -85 -13 -41 -27 -79 -32 -85 -4 -5
-8 -19 -8 -32 0 -13 -4 -23 -10 -23 -5 0 -10 -11 -10 -24 0 -14 -4 -28 -10
-31 -5 -3 -10 -16 -10 -29 0 -12 -4 -26 -8 -31 -5 -6 -19 -44 -32 -85 -13 -41
-27 -79 -32 -85 -4 -5 -8 -19 -8 -32 0 -13 -4 -23 -10 -23 -5 0 -10 -13 -10
-30 0 -16 -4 -30 -10 -30 -5 0 -10 -10 -10 -23 0 -13 -4 -27 -8 -32 -5 -6 -19
-44 -32 -85 -13 -41 -27 -79 -32 -85 -4 -5 -8 -19 -8 -31 0 -13 -4 -26 -10
-29 -5 -3 -10 -17 -10 -31 0 -13 -4 -24 -10 -24 -5 0 -10 -11 -10 -24 0 -14
-4 -28 -10 -31 -5 -3 -10 -16 -10 -29 0 -12 -4 -26 -8 -31 -5 -6 -19 -44 -32
-85 -13 -41 -27 -79 -32 -85 -4 -5 -8 -19 -8 -32 0 -13 -4 -23 -10 -23 -5 0
-10 -11 -10 -24 0 -14 -4 -28 -10 -31 -5 -3 -10 -16 -10 -29 0 -12 -4 -26 -8
-31 -5 -6 -19 -44 -32 -85 -13 -41 -27 -79 -32 -85 -4 -5 -8 -19 -8 -31 0 -13
-4 -26 -10 -29 -5 -3 -10 -17 -10 -31 0 -13 -4 -24 -10 -24 -5 0 -10 -9 -10
-20 0 -11 -4 -28 -9 -38 -5 -9 -24 -48 -42 -87 -18 -38 -40 -79 -49 -90 -28
-37 -102 -103 -129 -115 -14 -7 -34 -16 -43 -21 -10 -5 -26 -9 -36 -9 -10 0
-22 -4 -27 -9 -12 -11 -62 -18 -220 -30 -255 -21 -286 -24 -291 -32 -3 -5 -14
-9 -25 -9 -11 0 -31 -11 -44 -25 -35 -34 -33 -80 3 -112 27 -24 29 -24 167
-18 230 11 677 9 885 -4 107 -7 357 -15 555 -17 317 -5 366 -3 412 11 60 19
80 35 89 71 5 19 -1 31 -24 54 -17 16 -44 32 -59 35 -15 3 -44 10 -63 15 -19
5 -80 12 -135 14 -249 13 -422 28 -491 42 -59 11 -112 107 -100 180 3 22 9 58
12 82 4 23 11 45 15 48 5 3 9 20 9 39 0 19 5 37 10 40 6 3 10 17 10 31 0 13 4
32 9 42 5 9 14 37 21 62 7 25 16 53 21 62 5 10 9 29 9 43 0 14 5 25 10 25 6 0
10 13 10 29 0 17 5 33 10 36 6 3 10 17 10 30 0 13 5 27 10 30 6 3 10 17 10 30
0 13 5 27 10 30 6 3 10 17 10 30 0 13 5 27 10 30 6 3 10 17 10 31 0 13 5 24
10 24 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 10 10 23 0 13 4 27 8 32 5 6 19
44 32 85 13 41 27 79 32 85 4 5 8 19 8 32 0 13 5 23 10 23 6 0 10 11 10 24 0
14 4 27 8 30 4 3 14 28 22 56 8 28 18 53 22 56 4 3 8 16 8 30 0 13 5 24 10 24
6 0 10 11 10 24 0 14 4 27 8 30 4 3 14 28 22 56 8 28 18 53 22 56 4 3 8 16 8
30 0 13 4 24 8 24 5 0 15 23 22 51 8 27 18 52 22 55 4 3 8 14 8 25 0 51 -46
49 1040 49 1099 0 1040 3 1040 -54 0 -14 5 -26 10 -26 6 0 10 -13 10 -30 0
-16 5 -30 10 -30 6 0 10 -13 10 -29 0 -17 5 -33 10 -36 6 -3 10 -17 10 -30 0
-13 5 -27 10 -30 6 -3 10 -17 10 -30 0 -13 5 -27 10 -30 6 -3 10 -17 10 -30 0
-13 5 -27 10 -30 6 -3 10 -15 10 -26 0 -10 4 -27 9 -37 5 -9 23 -64 41 -122
18 -58 36 -113 41 -122 5 -10 9 -27 9 -37 0 -11 5 -23 10 -26 6 -3 10 -17 10
-30 0 -13 5 -27 10 -30 6 -3 10 -19 10 -36 0 -16 5 -29 10 -29 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -11 10 -25 0 -14 4 -33 9 -43 5 -9 14 -37 21
-62 7 -25 16 -53 21 -62 5 -10 9 -29 9 -43 0 -14 5 -25 10 -25 6 0 10 -11 10
-25 0 -14 4 -33 9 -43 5 -9 15 -37 22 -62 7 -25 16 -49 21 -55 4 -5 8 -17 8
-27 0 -10 4 -26 9 -36 15 -29 31 -87 31 -110 0 -12 5 -22 10 -22 6 0 10 -13
10 -29 0 -17 5 -33 10 -36 6 -3 10 -19 10 -35 0 -16 5 -32 10 -35 6 -3 10 -27
10 -52 0 -54 -26 -83 -94 -103 -22 -7 -52 -16 -66 -20 -27 -9 -118 -23 -251
-39 -47 -6 -156 -11 -244 -11 -320 0 -445 -36 -445 -128 0 -23 43 -72 63 -72
9 0 19 -5 23 -12 5 -8 95 -9 358 -2 442 11 1789 12 2251 1 l350 -9 28 25 c24
22 28 32 25 69 -3 39 -7 45 -43 64 -49 25 -98 32 -310 44 -296 17 -371 37
-453 117 -56 54 -109 151 -143 258 -7 22 -17 44 -21 50 -4 5 -8 19 -8 32 0 13
-4 23 -10 23 -5 0 -10 11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 55 -7 28
-17 51 -22 51 -4 0 -8 14 -8 30 0 17 -4 30 -8 30 -5 0 -15 23 -22 51 -8 27
-18 52 -22 55 -4 3 -8 16 -8 30 0 13 -4 24 -10 24 -5 0 -10 11 -10 24 0 14 -4
27 -8 30 -4 3 -14 28 -22 56 -8 28 -18 53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24
-10 24 -5 0 -10 9 -10 20 0 20 -4 29 -28 77 -7 13 -12 32 -12 43 0 11 -4 20
-10 20 -5 0 -10 11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 56 -8 28 -18 53
-22 56 -4 3 -8 16 -8 30 0 13 -4 24 -10 24 -5 0 -10 11 -10 24 0 14 -4 27 -8
30 -4 3 -14 28 -22 56 -8 28 -18 53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24 -10
24 -5 0 -10 9 -10 20 0 11 -4 29 -10 40 -5 11 -14 29 -20 40 -5 11 -10 29 -10
40 0 11 -4 20 -10 20 -5 0 -10 11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 56
-8 28 -18 53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24 -10 24 -5 0 -10 11 -10 24 0
14 -4 27 -8 30 -4 3 -14 28 -22 55 -7 28 -17 51 -22 51 -4 0 -8 14 -8 30 0 17
-4 30 -8 30 -5 0 -15 23 -22 51 -8 27 -18 52 -22 55 -4 3 -8 16 -8 30 0 13 -4
24 -10 24 -5 0 -10 11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 56 -8 28 -18
53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24 -10 24 -5 0 -10 9 -10 20 0 11 -4 29
-10 40 -5 11 -14 29 -20 40 -5 11 -10 29 -10 40 0 11 -4 20 -10 20 -5 0 -10
11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 56 -8 28 -18 53 -22 56 -4 3 -8
16 -8 30 0 13 -4 24 -10 24 -5 0 -10 9 -10 20 0 11 -4 29 -10 40 -5 11 -14 29
-20 40 -5 11 -10 29 -10 40 0 11 -4 20 -10 20 -5 0 -10 11 -10 24 0 14 -4 27
-8 30 -4 3 -14 28 -22 56 -8 28 -18 53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24
-10 24 -5 0 -10 9 -10 20 0 11 -4 29 -10 40 -5 11 -14 29 -20 40 -5 11 -10 29
-10 40 0 11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17 -4 30 -8 30 -4 0 -14 21
-21 48 -8 26 -18 54 -22 62 -4 8 -13 35 -20 60 -7 25 -16 49 -21 54 -4 6 -8
20 -8 33 0 13 -4 23 -8 23 -5 0 -15 23 -22 51 -8 27 -18 52 -22 55 -4 3 -8 16
-8 30 0 13 -4 24 -10 24 -5 0 -10 11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22
56 -8 28 -18 53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24 -8 24 -5 0 -15 23 -22 51
-8 27 -18 52 -22 55 -4 3 -8 16 -8 30 0 13 -4 24 -10 24 -5 0 -10 10 -10 23 0
13 -4 27 -8 33 -4 5 -14 27 -21 49 -7 22 -17 51 -23 65 -19 45 -26 64 -39 105
-7 22 -17 44 -21 49 -4 6 -8 20 -8 33 0 13 -4 23 -10 23 -5 0 -10 9 -10 20 0
11 -4 29 -10 40 -5 11 -14 29 -20 40 -5 11 -10 29 -10 40 0 11 -4 20 -10 20
-5 0 -10 10 -10 23 0 13 -4 27 -8 32 -4 6 -14 28 -21 50 -13 41 -20 60 -39
105 -6 14 -16 43 -23 65 -7 22 -17 44 -21 50 -4 5 -8 19 -8 32 0 13 -4 23 -10
23 -5 0 -10 11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 55 -7 28 -17 51 -22
51 -4 0 -8 11 -8 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 56 -8 28 -18 53 -22 56
-4 3 -8 16 -8 30 0 13 -4 24 -10 24 -5 0 -10 11 -10 24 0 14 -4 27 -8 30 -4 3
-14 28 -22 56 -8 28 -18 53 -22 56 -4 3 -8 16 -8 30 0 13 -4 24 -10 24 -5 0
-10 11 -10 24 0 14 -4 27 -8 30 -4 3 -14 28 -22 56 -8 28 -18 53 -22 56 -4 3
-8 16 -8 30 0 13 -4 24 -10 24 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10
10 -10 23 0 13 -4 27 -8 33 -5 5 -19 43 -32 84 -13 41 -27 79 -32 85 -4 5 -8
19 -8 31 0 13 -4 26 -10 29 -5 3 -10 15 -10 26 0 24 -39 69 -59 68 -9 0 -26
-11 -38 -24z m-257 -1729 c8 -8 14 -24 14 -35 0 -11 4 -22 8 -25 4 -3 14 -28
22 -56 8 -28 18 -53 22 -56 4 -3 8 -16 8 -29 0 -13 5 -27 10 -30 6 -3 10 -17
10 -31 0 -13 5 -24 10 -24 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -11
10 -24 0 -14 5 -28 10 -31 6 -3 10 -17 10 -30 0 -13 4 -26 8 -29 4 -3 14 -28
22 -56 8 -28 18 -53 22 -56 4 -3 8 -16 8 -29 0 -13 5 -27 10 -30 6 -3 10 -17
10 -31 0 -13 5 -24 10 -24 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -10
10 -23 0 -13 4 -27 8 -32 5 -6 19 -44 32 -85 13 -41 27 -79 32 -85 4 -5 8 -19
8 -32 0 -13 5 -23 10 -23 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -11 10 -24 0 -14 4 -27 8 -30 4 -3 14 -28 22
-56 8 -28 18 -53 22 -56 4 -3 8 -16 8 -29 0 -13 5 -27 10 -30 6 -3 10 -17 10
-31 0 -13 5 -24 10 -24 6 0 10 -10 10 -23 0 -13 4 -27 8 -32 5 -6 19 -44 32
-85 13 -41 27 -79 32 -84 4 -6 8 -20 8 -33 0 -13 5 -23 10 -23 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -11 10 -24 0 -14 4 -27 8 -30 4 -3 14 -28 22
-56 8 -28 18 -53 22 -56 4 -3 8 -16 8 -30 0 -13 5 -24 10 -24 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -11 10 -24 0 -14 4 -27 8 -30 4 -3 14 -28 22
-56 8 -28 18 -53 22 -56 4 -3 8 -16 8 -30 0 -13 5 -24 10 -24 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -11 10 -24 0 -14 4 -27 8 -30 4 -3 14 -28 22
-56 8 -28 18 -53 22 -56 4 -3 8 -16 8 -30 0 -13 5 -24 10 -24 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -11 10 -24 0 -14 5 -28 10 -31 6 -3 10 -10 10
-16 0 -5 -367 -9 -960 -9 -593 0 -960 4 -960 9 0 6 5 13 10 16 6 3 10 17 10
30 0 13 5 27 10 30 6 3 10 17 10 30 0 13 5 27 10 30 6 3 10 17 10 30 0 13 5
27 10 30 6 3 10 17 10 31 0 13 5 24 10 24 6 0 10 14 10 30 0 17 5 30 10 30 6
0 10 14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 11 10
24 0 14 5 28 10 31 6 3 10 17 10 30 0 13 5 27 10 30 6 3 10 15 10 26 0 10 4
27 10 37 5 9 28 73 50 142 22 69 45 133 50 142 6 10 10 27 10 37 0 11 5 23 10
26 6 3 10 17 10 31 0 13 5 24 10 24 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10
11 10 24 0 14 5 28 10 31 6 3 10 16 10 29 0 12 4 26 8 31 5 6 19 44 32 85 13
41 27 79 32 85 4 5 8 19 8 31 0 13 5 26 10 29 6 3 10 17 10 31 0 13 5 24 10
24 6 0 10 10 10 23 0 13 4 27 8 32 5 6 19 44 32 85 13 41 27 79 32 85 4 5 8
24 8 42 0 18 5 33 10 33 6 0 10 10 10 23 0 13 4 27 8 32 5 6 19 44 32 85 13
41 27 79 32 84 4 6 8 20 8 33 0 13 5 23 10 23 6 0 10 10 10 23 0 13 4 27 8 33
4 5 14 27 21 49 7 22 17 51 23 65 19 45 26 64 39 105 7 22 17 44 21 50 4 5 8
19 8 32 0 13 5 23 10 23 6 0 10 9 10 20 0 20 4 29 28 77 7 13 12 32 12 43 0
11 4 20 8 20 5 0 15 23 22 50 7 28 15 50 18 50 2 0 10 -6 18 -14z"/>
<path  d="M5915 4508 c-16 -6 -38 -14 -47 -19 -10 -5 -25 -9 -33 -9 -8 0 -15
-4 -15 -10 0 -5 -6 -10 -13 -10 -7 0 -23 -9 -35 -20 -12 -11 -25 -20 -29 -20
-14 0 -89 -76 -109 -109 -10 -17 -22 -31 -26 -31 -4 0 -8 -9 -8 -20 0 -11 -4
-20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -9 -20 -15 0 -44 -142 -44 -210
1 -64 14 -149 24 -156 5 -3 9 -16 9 -30 0 -13 5 -24 10 -24 6 0 10 -9 10 -20
0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 4 -20 8 -20 4 0 16 -14 26 -31 21
-36 94 -109 108 -109 5 0 18 -9 30 -20 12 -11 28 -20 35 -20 7 0 13 -4 13 -10
0 -5 7 -10 15 -10 8 0 23 -4 33 -9 46 -23 98 -31 205 -31 66 0 118 4 122 10 3
6 19 10 36 10 16 0 29 5 29 10 0 6 6 10 13 10 18 0 67 24 67 33 0 4 6 7 14 7
18 0 137 117 155 153 8 15 18 27 23 27 4 0 8 9 8 20 0 11 3 20 8 20 9 0 32 72
32 99 0 11 5 23 10 26 6 3 10 50 10 105 0 55 -4 102 -10 105 -5 3 -10 15 -10
26 0 27 -23 99 -32 99 -5 0 -8 9 -8 20 0 11 -4 20 -8 20 -5 0 -15 12 -23 28
-18 35 -137 152 -155 152 -8 0 -14 3 -14 8 0 8 -49 32 -67 32 -7 0 -13 5 -13
10 0 6 -13 10 -29 10 -17 0 -33 5 -36 10 -8 13 -240 11 -280 -2z"/>
<path  d="M13735 4510 c-3 -5 -14 -10 -25 -10 -20 0 -103 -40 -108 -52 -2 -5
-10 -8 -18 -8 -18 0 -164 -146 -164 -165 0 -8 -3 -15 -7 -15 -9 0 -33 -49 -33
-67 0 -7 -4 -13 -9 -13 -15 0 -24 -69 -24 -190 0 -121 9 -190 24 -190 5 0 9
-6 9 -13 0 -18 24 -67 33 -67 4 0 7 -6 7 -14 0 -20 144 -166 163 -166 9 0 17
-3 19 -7 5 -13 88 -53 108 -53 11 0 22 -4 25 -10 4 -6 57 -10 127 -10 98 0
133 4 181 21 59 21 113 49 152 79 56 43 144 146 145 168 0 6 5 12 10 12 6 0
10 9 10 19 0 11 5 23 10 26 6 3 10 16 10 29 0 12 5 27 11 33 7 7 11 59 11 143
0 84 -4 136 -11 143 -6 6 -11 19 -11 28 0 19 -51 117 -79 152 -34 45 -124 127
-137 127 -3 0 -18 8 -32 19 -62 43 -142 61 -270 61 -70 0 -123 -4 -127 -10z"
      />
  </g>
</svg>
</div>
)

export default LoadingSpinner


